import React, { Component } from "react";
import ZoomIn from "@material-ui/icons/ZoomIn";
import COLORS from "../theme/colors";
import ImageLightbox, { toImageSrc } from "./ImageLightbox";

// order of the work flow in the app
const SIGNATURES = [
  { field: "sign1", title: "Podpis pred pričetkom", hint: "Soglasje stranke o možnih poškodbah" },
  { field: "sign3", title: "Podpis stranke na koncu", hint: "Potrditev delovnega naloga" },
  { field: "sign2", title: "Podpis monterja na koncu", hint: "Zaključek naročila" }
];

const has = value => typeof value === "string" && value.trim().length > 0;

export const thumbStyles = {
  grid: { display: "grid", gridTemplateColumns: "repeat(auto-fill, minmax(240px, 1fr))", gap: 16, maxWidth: 900, padding: "8px 0 4px" },
  card: { border: `1px solid ${COLORS.border}`, borderRadius: 12, background: "#fff", overflow: "hidden" },
  cardHead: { padding: "12px 14px 10px" },
  cardTitle: { color: COLORS.text, fontSize: 14, fontWeight: 600 },
  cardHint: { marginTop: 2, color: COLORS.muted, fontSize: 12 },
  thumbButton: {
    position: "relative",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    width: "100%",
    height: 130,
    padding: 10,
    border: 0,
    borderTop: `1px solid ${COLORS.grid}`,
    background: COLORS.field,
    cursor: "zoom-in"
  },
  thumb: { maxWidth: "100%", maxHeight: "100%", objectFit: "contain" },
  zoom: {
    position: "absolute",
    right: 8,
    bottom: 8,
    width: 28,
    height: 28,
    padding: 4,
    borderRadius: 8,
    color: COLORS.primary,
    background: "rgba(255,255,255,0.92)",
    boxShadow: "0 1px 4px rgba(31,41,51,0.15)"
  },
  missing: {
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    height: 130,
    borderTop: `1px solid ${COLORS.grid}`,
    color: COLORS.muted,
    fontSize: 13,
    background: COLORS.field
  }
};

/** Podpisi tab: the three signatures as small cards; click one to see it large. */
class Base64Image extends Component {
  state = { open: null };

  render() {
    const record = this.props.record || {};
    const signed = SIGNATURES.filter(s => has(record[s.field]));
    const images = signed.map(s => ({ title: s.title, src: toImageSrc(record[s.field], "image/png") }));

    return (
      <div>
        <div style={thumbStyles.grid}>
          {SIGNATURES.map(s => {
            const index = signed.indexOf(s);
            return (
              <div key={s.field} style={thumbStyles.card}>
                <div style={thumbStyles.cardHead}>
                  <div style={thumbStyles.cardTitle}>{s.title}</div>
                  <div style={thumbStyles.cardHint}>{s.hint}</div>
                </div>
                {index === -1 ? (
                  <div style={thumbStyles.missing}>Ni podpisa</div>
                ) : (
                  <button
                    type="button"
                    style={thumbStyles.thumbButton}
                    onClick={() => this.setState({ open: index })}
                    title="Odpri večji prikaz"
                    aria-label={`${s.title} – odpri večji prikaz`}
                  >
                    <img src={images[index].src} alt={s.title} style={thumbStyles.thumb} />
                    <ZoomIn style={thumbStyles.zoom} />
                  </button>
                )}
              </div>
            );
          })}
        </div>
        <ImageLightbox
          images={images}
          index={this.state.open}
          onChange={open => this.setState({ open })}
          onClose={() => this.setState({ open: null })}
        />
      </div>
    );
  }
}

export default Base64Image;
